import Warning from '@/components/atoms/text/Warning.vue'
import { formatPrice } from '@/util/format'
import Vue from 'vue'

export const discountPriceView = (price: number) => Vue.extend({
  name: 'coupon-discount-price',
  components: { Warning },
  template: `
  <warning
    class="p-order-confirm-overview__label discount-price col-5 warning"
  >
    -${formatPrice(price)}
  </warning>
  `,
})

export const emptyView = (name: string) => Vue.extend({
  name,
  template: `<div name="${name}"></div>`,
})
